module.exports = __webpack_public_path__ + "img/05.5d49ccc3.png";